import PaperBase from '../../Paper/PaperBase';
import MarkingUtils from '../../../utils/marking.utils';
import LearningGrowthCard from './LearningGrowthCard';
import { Tooltip } from '@mui/material';
import {
  ContentTooltipMarkingInfo,
  useStyles
} from '../../Dashboard/Assessment/Classes/MarkingClasses/ContentTooltip/ContentTooltip';

const CardGranularStep = ({
  lcs = [],
  levelId,
  level,
  nextLevel,
  currentCurriculum,
  completed,

  learningGrowth = [],
  loadingLearningGrowth,
  size,
  direction = 'column',
  top = '0px',
}) => {
  const classes = useStyles();
  let findLG = null;
  const levels = currentCurriculum?.levels || [];
  const marking = currentCurriculum?.marking || [];
  const minMarking = currentCurriculum?.marking?.find((item) => item.minValue) || {};
  const maxMarking = currentCurriculum?.marking?.find((item) => item.maxValue) || minMarking;
  const maxLevel = MarkingUtils.getMarkingLevel(
      marking,
      levels,
      lcs,
      completed
    );
  if (lcs.every((x) => x.granularSteps)) {
    let lcgs = [];
    let gss = [];
    lcs.forEach((lc) => {
      const granularSteps = lc.granularSteps
        ?.filter((step) => step.levelId === levelId)
        .map((_, i) => String(i));
      lcgs = [...lcgs, ...granularSteps];
      lc.granularSteps?.forEach((gs) => {
        const find = gss.find((item) => item.id === gs.id);
        if (!find) {
          gss.push(gs);
        }
      });
    });
    lcgs = [...new Set(lcgs)];
    gss = MarkingUtils.sortGranularSteps(levels, gss);

    const items = lcgs;
    if (items.length > 0) {
      let renderItems = items.map((item, index) => {
        const isLevel = index === 0;
        if (!isLevel && !nextLevel) {
          return null;
        }

        const colors = MarkingUtils.getColorLabel(marking, maxLevel, isLevel, level);
        return (
          <div
            key={`granular-steps-${levelId}-gs-${item}`}
            className={`flex ${direction === 'row' ? 'flex-col' : 'w-full'} flex-nowrap gap-1`}
          >
            <PaperBase
              backgroundColor={colors.backgroundColor}
              color={colors.color}
              outline={isLevel ? null : `1px solid ${colors?.outline}`}
              children={isLevel ? level.code : `WT ${nextLevel?.code}`}
              // className={`font-bold sticky z-10 ${direction === 'row' ? ' top-0' : 'left-0 '}`}
              className={`font-bold sticky z-10 px-2 text-ellipsis ${
                direction === 'row' ? `text-lg top-${top} ` : 'left-0 min-w-100px max-w-100px'
              }`}
              style={{
                width: size,
                // height: size,
                // fontSize: 9
                height: direction === 'row' ? size : 'auto',
                fontSize: direction === 'row' ? '1.125rem' : 'auto'
              }}
            />
            {lcs.map((lc, ilc) => {
              let findMarking = minMarking;
              const levelData = {
                ...level,
                levelIndex: index,
                name: isLevel ? level.name : `Working towards ${nextLevel?.name}`
              };
              const gsslc = lc.granularSteps
                ?.filter((step) => step.levelId === levelId)
                ?.map((item) => ({
                  ...item,
                  position: parseInt(item.id.split('gs-')[1])
                }))
                ?.sort((a, b) => a.position - b.position);

              const find = gsslc[index];

              let generalPosition = 0;
              if (find) {
                levelData.definition = find?.definition || '';
                const gsIndex = MarkingUtils.sortGranularSteps(levels, [...lc.granularSteps]).findIndex(
                  (item) => item.id === find.id
                );
                levelData.position = gsIndex;
                find.generalPosition = gsIndex;
                // findMarking = marking.find((item) => item._id === find?.[completed]) || minMarking;
              }

              const gsidx = MarkingUtils.sortGranularSteps(levels, gss).findIndex(
                (el) => el.id === `level-${levelId}-gs-${item}`
              );
              generalPosition = gsidx;
              const log = find?.logs?.find(
                (log) =>
                  log.markingType === completed &&
                  log.exists &&
                  log.marking !== minMarking._id &&
                  log.definition
              );

              if (log) {
                find.definition = (
                  <Tooltip
                    id={`granular-steps-${levelId}-gs-${item}-lc-${lc._id}-current-marking-${log._id}-${ilc}`}
                    arrow
                    placement='top'
                    title={
                      <div className='py-1'>
                        <ContentTooltipMarkingInfo marking={log} />
                      </div>
                    }
                    classes={{ tooltip: classes.customWidth }}
                  >
                    <span className='text-ellipsis text-sm cursor-pointer'>{levelData.definition}</span>
                  </Tooltip>
                );
              }

              findLG = learningGrowth?.find(
                (item) => item.lcId === lc._id && item.gsId === find?.id && lc.ulId === item.ulId
              );
              let minLG = 999999999999999999;
              let maxLG = 0;
              let findMin = null;
              let findMax = null;

              learningGrowth?.forEach((item) => {
                if (item.lcId === lc._id && lc.ulId === item.ulId) {
                  const gsindex = MarkingUtils.sortGranularSteps(levels, gss).findIndex(
                    (gs) => gs.id === item.id
                  );
                  if (gsindex < minLG) {
                    minLG = gsindex;
                    findMin = {
                      ...item,
                      generalPosition: gsindex
                    };
                  }
                  if (gsindex > maxLG) {
                    maxLG = gsindex;
                    findMax = {
                      ...item,
                      generalPosition: gsindex
                    };
                  }
                }
              });

              // const lgByLc = learningGrowth?.filter(
              //   (item) => item.lcId === lc._id && lc.ulId === item.ulId
              // );

              // let findFirst = lgByLc[0];
              // let findLast = lgByLc[lgByLc.length - 1];

              if (!findLG) {
                if (
                  generalPosition > findMin?.generalPosition &&
                  generalPosition < findMax?.generalPosition
                ) {
                  findLG = {
                    id: find?.id,
                    generalPosition,
                    typeGrowth: 'continue/level',
                    type: 'same'
                  };
                }
              }

              if (findLG) {
                findLG.index = findLG.gsPosition;
                findLG.markingType = completed;
              }
              if (generalPosition > findMin?.generalPosition ) {
                if (findMin?.typeGrowth?.indexOf('down') > -1 && findLG?.typeGrowth === 'continue/level') {
                  findMarking = minMarking;
                } else {
                  findMarking = maxMarking;
                }
              } else {
                if (findLG) {
                  findMarking = findLG;
                }
              }
              const id = `granular-steps-${levelId}-gs-${item}-lc-${lc._id}-ul-${lc.ulId || 'main'}-class-${
                lc.classId || 'main'
              }-index-${ilc}`;
              return (
                <LearningGrowthCard
                  findLG={findLG}
                  lc={lc}
                  level={levelData}
                  currentCurriculum={currentCurriculum}
                  size={size}
                  direction={direction}
                  id={id}
                  key={id}
                  backgroundColor={find ? findMarking?.primaryColor : null}
                  color={find ? findMarking?.secondaryColor : null}
                  step={{ ...find }}
                  isLoading={loadingLearningGrowth}
                  generalPosition={generalPosition}
                  lgMin={findMin?.generalPosition}
                  lgMax={findMax?.generalPosition}
                />
              );
            })}
          </div>
        );
      });

      if (direction === 'column') {
        renderItems = renderItems.reverse();
      }
      return renderItems;
    }
  }

  return [];
};

export default CardGranularStep;
